module.exports = __webpack_public_path__ + "static/media/lose.659e1ad1.svg";